module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "需代课请假",
      "width": "60%"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "leaveForm",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.leaveParam,
      "rules": _vm.leaveRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请假类型"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    model: {
      value: (_vm.leaveParam.leaveType),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "leaveType", $$v)
      },
      expression: "leaveParam.leaveType"
    }
  }, _vm._l((_vm.$constant.tchLeaveType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "startTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间"
    },
    on: {
      "on-change": _vm.startTimeChange
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "endTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "结束时间"
    },
    on: {
      "on-change": _vm.endTimeChange
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.onBookLessonOpened
    }
  }, [_vm._v("查看涉及课节")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Row', [_c('Form-item', {
    attrs: {
      "label": "请假原因类别",
      "prop": "remarkType"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "不知道就问主管"
    },
    model: {
      value: (_vm.leaveParam.remarkType),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remarkType", $$v)
      },
      expression: "leaveParam.remarkType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假原因",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.leaveParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "remark", $$v)
      },
      expression: "leaveParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.bookLessonOpenedColumn,
      "data": _vm.bookLessonOpenedList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("操作后记得点击“保存”按钮")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f04bf4e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchLeaveModal.vue
// module id = 1983
// module chunks = 8